/**
 * Shared widget chrome, used by every dashboard card rather than copied per
 * widget — the dashboard reads as one surface only if the cards
 * on it are literally the same card.
 */
export const card: React.CSSProperties = {
  background: "var(--surface)",
  padding: 16,
  borderRadius: 10,
  boxShadow: "var(--shadow-1)",
  display: "flex",
  flexDirection: "column",
  gap: 12,
};
export const head: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  color: "var(--ink)",
  fontSize: 14,
};
export const list: React.CSSProperties = {
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: 8,
};
export const itemLink: React.CSSProperties = {
  textDecoration: "none",
  display: "block",
  padding: 8,
  borderRadius: 6,
};
export const moreLink: React.CSSProperties = { color: "var(--brand-ink)", fontSize: 12, textDecoration: "none" };
export const empty: React.CSSProperties = { color: "var(--ink-4)", fontSize: 13, margin: 0 };
